import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { KpiOpenedRoutesAPI } from '../constants';
import { ChartFilter, KpiOpened } from '../interfaces';

import { BaseService } from './BaseService';

@Injectable({})
export class KpiOpnenedService extends BaseService {

  static list(): Promise<KpiOpened[]> {
    return HttpService.get(KpiOpenedRoutesAPI.KPIOPENED_LIST, {}, {})
      .then(response => {
        return response.body as KpiOpened[];
      });
  }

  static total(filter: ChartFilter | undefined): Promise<string> {
    return HttpService.get(KpiOpenedRoutesAPI.KPIOPENED_OS_TOTAL, filter)
      .then(response => {
        return response.body as string;
      });
  }

}
